export default class FactureCloturePopupController {
	static $inject = [
		'$scope',
		'$stateParams',
		'FacturesService',
		'notification',
		'ModalService',
		'$uibModal',
		'moment',
		'$translate',
		'globalizationManagementService'
	];

	constructor($scope, $stateParams, FacturesService, notification, ModalService, $uibModal, moment, $translate, globalizationManagementService) {
		this.$scope = $scope;
		this.$stateParams = $stateParams;
		this.FacturesService = FacturesService;
		this.notification = notification;
		this.ModalService = ModalService;
		this.$uibModal = $uibModal;
		this.moment = moment;
		this.$translate = $translate;

		this.dateFormat = globalizationManagementService.getCurrentLanguage().dateFormat;
	}

	async $onInit() {
		this.isChangeFactureDate = false;
		this.dateDernierTicket = this.resolve.dateDernierTicket;
		this.isDateClotureBefore = false;
		this.isNewFactureDateBeforeDernierTicket = false;
		this.newFactureDate = this.resolve.dateDernierTicket;
	}

	annuler() {
		this.modalInstance.dismiss();
	}

	confirm() {
		this.modalInstance.close({
			...this.resolve,
			nouvelleDateFactureComptant: this.isChangeFactureDate && !this.isDateClotureBefore ? this.newFactureDate : null
		});
	}

	onChangeDate() {
		this.isNewFactureDateBeforeDernierTicket = this.moment(this.newFactureDate, this.dateFormat).isBefore(
			this.moment(this.dateDernierTicket, this.dateFormat)
		);
	}
}
